<div class="container">
      <section class="inner-container">
        <main>
          <div class="contact-form" style="background-image: url(images/login-bg.jpg); background-size: cover; height: 80vh; padding-top: 9vh">
            <div class="row">
              <div class="col-md-4">
              </div>
              <!--; margin-left: 3em; margin-right: 3em; max-width: 500px-->
              <div class="col-md-4" style="border-radius: 25px; background: white; opacity: 0.9; padding: 3em">
                <form name="passwordForm" id="passwordForm" novalidate data-k2-validation="true" class="general-form" #passwordForm="ngForm">
                  <h5 class="title-form">Forgot password</h5>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group">
                        <input type="text" name="email" id="email" placeholder="" #email class="custom-input" required trim>
                        <label>E-mail</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="group mid">
                      <button type="submit" class="btn btn-primary btn-block" [disabled]="passwordForm.form.invalid" [ngClass]="{'disabled': passwordForm.form.invalid}" (click)="sendEmail(email.value)">Submit</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </main>
      </section>
    </div>

